export default class AbstractAuthenticationProvider {
	constructor() {
		this.isReady = false;
		this.readyListener = null;
		this.onStateChange = null;
	}

	get onReady() {
		return this.readyListener;
	}

	set onReady(onReady) {
		this.readyListener = onReady;

		if (onReady && this.isReady) {
			setTimeout(() => {
				if (this.readyListener === onReady) {
					onReady();
				}
			}, 0);
		}
	}

	getLogoutData() {
		return {};
	}

	isSignedIn() {
		return false;
	}

	getAuthorizationToken() {
		return false;
	}

	getToken(callback) {
		if (this.isReady) {
			this.getAuthorizationToken((error, token) => {
				callback(error, token);
			});

			return;
		}

		this.onReady = () => {
			this.isReady = true;
			this.getToken(callback);
		};
	}
}
